import { PropsWithChildren, useEffect } from 'react';

import { usePaymentStore } from '../stores/payment-store';
import { useAuthStore } from '../stores/auth-store';

const PaymentProvider = ({ children }: PropsWithChildren) => {
    const { oauthToken } = useAuthStore();
    const { fetchMethods, fetchBanks, fetchCurrencies } = usePaymentStore();

    useEffect(() => {
        if (oauthToken) {
            fetchMethods(oauthToken);
            fetchBanks(oauthToken);
            fetchCurrencies(oauthToken);
        }
    }, [oauthToken]);

    return <>{children}</>;
};

export { PaymentProvider };
